import React from 'react';
import { formatMoney } from 'src/helpers/money-format';

const ProductPrice = (props) => {
  const { product, moneyFormat } = props;

  return (
    <div className='BC-Component-ProductPrice'>
      {product.compare_at_price_min ? (
        <>
          <span className='price-sale'>{formatMoney(product.price_min, moneyFormat)}</span>
          <span className='price-compare'>{formatMoney(product.compare_at_price_min, moneyFormat)}</span>
        </>
      ) : (
        <span className='price'>{formatMoney(product.price_min, moneyFormat)}</span>
      )}
    </div>
  );
};

export default ProductPrice;